import { getEnv } from 'shared/config/constants';

export const ENTRYWAYS_PROGRAM_BK = 'entryways-program';

export const getEntrywaysEndpointUrl = () => {
  const env = getEnv();

  if (env === 'staging') {
    return 'https://mclass-enrollment.staging.wgen.net/';
  }

  if (env === 'prod') {
    return 'https://mclass-enrollment.mclass.amplify.com/';
  }

  return 'https://mclass-enrollment.aws.wgen.net/';
};
